import type { MobileSignSessionStatus } from '@shared/types/process';

// A consumed session must represent an already committed service action.
export async function resumeMobileSign({
    status,
    sessionId,
    execute,
    getStatus,
    refresh,
}: {
    status: MobileSignSessionStatus;
    sessionId: string;
    execute: () => Promise<void>;
    getStatus: () => Promise<MobileSignSessionStatus>;
    refresh: () => Promise<void>;
}) {
    if (status.sessionId !== sessionId) {
        throw new Error('mobile sign session mismatch');
    }
    if (status.status === 'Consumed') {
        await refresh();
        return;
    }
    try {
        await execute();
    } catch (error) {
        // The other tab may have committed the action after our status request.
        let latest: MobileSignSessionStatus;
        try {
            latest = await getStatus();
        } catch {
            throw error;
        }
        if (latest.sessionId !== sessionId || latest.status !== 'Consumed') {
            throw error;
        }
        await refresh();
    }
}
